module.exports = __webpack_public_path__ + "static/img/C4D0018.2e99890.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intru/C4D0018.jpg
// module id = Xjlk
// module chunks = 0